

interface uploadParamsOptions {
  multiple?: boolean,
  accept?: string,
  success_text?: string
}

interface uploadParamsPostParams {
  action: string,
  field: string,
}

interface uploadParams {
  buttonLabel: string,
  action: 'UPLOAD',
  buttonClass?: string,
  options?: uploadParamsOptions,
  url?: string,
  postParams?: uploadParamsPostParams,
}

import Password from '../ComponentsExtends/Password.vue'
import FileInput from '../CommonIndependent/FileInput.vue'
import TreeForParams from '../ComponentsExtends/TreeForParams.vue'
import Xapi from '../../utils/xapi';
import InputNumber from 'primevue/inputnumber';
import Checkbox from 'primevue/checkbox';

export default {
  name: "Settings",
  props: {

    paramsUrl: {
      type: String,
      default: '/params',
    }

  },
  data() {
    return {
      paramsTree: null,
      paramsValues: {},
      xapi: Xapi,
    }
  },
  methods: {

    async upload(file, component, params: uploadParams) {

      if (!file)
        return;

      component.removeFile();

      try {

        Xapi.showBlockModal('Загрузка...');

        let formData = new FormData();
        formData.append('action', params?.postParams?.action);
        formData.append(params?.postParams?.field, file);

        await Xapi.postForm(
          params?.url,
          formData,
        );

        Xapi.xnotify(params?.options?.success_text ?? 'Операция выполнена успешно');

      } finally {
        Xapi.hideBlockModal();
      }

    },

    async get(url) {

      try {

        Xapi.showBlockModal('Выполняется запрос...');

        let response: any = await Xapi.get(url)

        if (response.data?.newParamsValues && (typeof response.data?.newParamsValues === 'object')) {

          for (let key in response.data?.newParamsValues) {
            this.paramsValues[key] = response.data?.newParamsValues[key];
          }

        } else {

          Xapi.xnotify(response.data?.notify ?? 'Запрос выполнен успешно');

        }

      } catch ($e) {
        console.error($e);
      } finally {
        Xapi.hideBlockModal();
      }

    },
    async save() {

      try {

        Xapi.showBlockModal('Сохранение параметров...');

        await Xapi.post(
          this.paramsUrl,
          {
            action: 'saveParams',
            params: this.paramsValues,
          },
        );

        await this.getParamsTree();
        Xapi.xnotify('Параметры сохранены')

      } finally {
        Xapi.hideBlockModal();
      }

    },

    async getParamsTree() {

      let response = await Xapi.post(
        this.paramsUrl,
        {
          action: 'getParamsTree',
        },
      );

      this.paramsTree = response.data.paramsTree;

    },

    async getParamsValues() {

      let response = await Xapi.post(
        this.paramsUrl,
        {
          action: 'getParamsValues',
        },
      );

      this.paramsValues = Array.isArray(response.data.paramsValues) ? {} : response.data.paramsValues;

    },

  },
  async mounted() {

    await Promise.all([this.getParamsTree(), this.getParamsValues()]);

  },
  components: {TreeForParams, InputNumber, Checkbox, Password, FileInput}
}
